// Shit happened, nuke local storage object
const emergency = (err) => {
    if (err) {
        console.error(err);
    }
    console.error("Error reading, writing or parsing stored object.\n" +
        "Local storage object is possibly corrupted and will be deleted.");
    clrstg();
};
const emptyStorage = () => {
    return {
        messages: [],
        oauth_pkce: {
            state: null,
            verifier: null
        },
        user: null,
        preferences: null
    };
};
export const getstg = () => {
    var _a, _b;
    let stg;
    try {
        stg = (_b = JSON.parse((_a = localStorage.getItem('kblabfront')) !== null && _a !== void 0 ? _a : '')) !== null && _b !== void 0 ? _b : emptyStorage();
    }
    catch (err) {
        emergency();
    }
    ;
    return stg && stg.oauth_pkce ? stg : emptyStorage();
};
export const setstg = (stg) => {
    try {
        localStorage.setItem('kblabfront', JSON.stringify(stg));
    }
    catch (err) {
        emergency();
    }
    ;
};
export const clrstg = () => {
    localStorage.removeItem('kblabfront');
};
